export default __webpack_public_path__ + "static/media/parallax2.07171419.png";